<div fxLayout="column" fxLayoutAlign="center center" class="container">
  <h2>Tischnummer eingeben</h2>
  <mat-form-field appearance="fill">
    <mat-label>Tischnummer eingeben</mat-label>
    <input type="number" matInput placeholder="Tischnummer eingeben" [(ngModel)]="tableNumber" (keyup.enter)="startOrder(false)" class="no-arrows no-focus" />
  </mat-form-field>
  <button mat-raised-button color="accent" (click)="startOrder(false)">Bestellung starten</button>
  <button class="voucher-btn" mat-raised-button color="accent" (click)="startOrder(true)" *ngIf="showItem('admin')">Bons drucken</button>
</div>
